<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('NAME')">
        <inputvalidation :formerror="formError" name="name">
          <b-form-input type="text" v-model="formData.name"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('ORDERNUM')">
        <inputvalidation :formerror="formError" name="orderNum">
          <b-form-input type="text" v-model="formData.orderNum"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'MeterValueForm',
    props: ['formData', 'formError'],
};
</script>
